import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { retrieveToken } from 'services/auth.service';
import LoginDisplay from './LoginDisplay';

class LoginContainer extends React.Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    login: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    loggedIn: PropTypes.bool.isRequired
  };

  state = {
    form: {
      Email: '',
      Password: ''
    },
    errors: {
      Email: undefined,
      Password: undefined
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.loading !== prevProps.loading && this.props.loggedIn) {
      const token = retrieveToken();
      if (token != null) {
        this.props.history.push('/');
      }
    }
  }

  onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.onSubmit();
    }
  }

  onChange = (newValue) => {
    this.setState({ form: newValue });
  }

  clearErrors = () => {
    const errors = {
      Email: undefined,
      Password: undefined
    };
    this.setState({ errors });
  }

  validateForm = () => {
    this.clearErrors();
    let isValid = true;
    const { form } = this.state;
    const errors = {};

    if (form.Email === '') {
      errors.Email = 'Please enter a username';
      isValid = false;
    }

    if (form.Password === '') {
      errors.Password = 'Please enter an Password';
      isValid = false;
    }

    if (isValid === false) {
      return errors;
    }
    return null;
  }

  onSubmit = () => {
    const errors = this.validateForm();
    if (errors === null) {
      const { login } = this.props;
      const { form } = this.state;
      login(form.Email, form.Password);
    } else {
      this.setState({ errors });
    }
  }

  signUpRedirect = () => {
    this.props.history.push('/setup/createorlogin');
  }

  forgotPasswordRedirect = () => {
    this.props.history.push('/login/forgotPassword');
  }

  render() {
    return (
      <LoginDisplay
        value={ this.state.form }
        onChange={ this.onChange }
        errors={ this.state.errors }
        onKeyDown={ this.onKeyDown }
        onSubmit={ this.onSubmit }
        signUpRedirect={ this.signUpRedirect }
        forgotPasswordRedirect={ this.forgotPasswordRedirect }
        loading={ this.props.loading }
      />
    );
  }
}

export default withRouter(LoginContainer);
